import noop from 'lodash/noop';
import { call, cancelled, put, select } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import * as AppConstants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { branch, pipe } from '../../../sagas/Helpers';
import { putAndWait } from '../../../sagas/TaskManager';
import Logger from '../../../tools/Logger';
import * as AppUtils from '../../../utils';

import * as StartStationHelpers from './helpers';

const log = Logger.child({ component: 'mediator/useCases/startStation' });

export function* startStation(action) {
  const { sourceId, pandoraId, pageUrl } = action.payload;
  const sourceType = AppConstants.SourceTypes.SourceTypes.STATION;
  let error;
  const isMobileWeb = yield select(AppUtils.Capabilities.isMobileWeb);

  if (isMobileWeb) {
    const musicId = AppUtils.PandoraIdUtil.getMusicIdFromPandoraId(pandoraId);
    window.location = yield select(AppUtils.Route.getMobileLongLink, {
      pageUrl,
      feature: AppConstants.Urls.deepLinkParams.BACKSTAGE_PAGE,
      type: sourceType,
      id: musicId,
    });

    return;
  }

  yield put(AppActions.Integrations.startingSource({ sourceId }));
  yield put(getInDomain('analytics.actions.ttmSourceChangedTransitionFromMusic', noop)());
  try {
    yield call(
      branch(
        StartStationHelpers.isAPSEnabled,
        pipe([
          StartStationHelpers.setShuffleMode,
          StartStationHelpers.setOrCreateNextStation,
          StartStationHelpers.forceRerouteOrRerouteBasedOnTier,
          StartStationHelpers.playAPSSource,
        ]),
        pipe([
          StartStationHelpers.checkForStationRadio,
          StartStationHelpers.checkForStationRights,
          StartStationHelpers.setShuffleMode,
          StartStationHelpers.checkStationChangeInterruption,
          StartStationHelpers.setOrCreateNextStation,
          StartStationHelpers.shouldPlayAd,
          StartStationHelpers.setStationPlaylist,
          StartStationHelpers.resetAPS,
          StartStationHelpers.forceRerouteOrRerouteBasedOnTier,
          StartStationHelpers.playTrackFromStation,
        ]),
      ),
      action,
    );
    yield put(AppActions.Integrations.sourceStarted({ sourceId }));
  } catch (e) {
    error = e;
    log.error(error);
    yield call(
      putAndWait,
      getInDomain('stations.actions.handleStartStationError')({
        pandoraId,
        error,
        errorRecoveryPath: action.payload.errorRecoveryPath,
      }),
    );
  } finally {
    if (error || (yield cancelled())) {
      yield put(AppActions.Integrations.startSourceIncomplete({ sourceId }));
    }
  }
}
